var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "meeting-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.079,
    height: 30,
    viewBox: "0 0 21.079 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M.14,7.877l7.2-7.8,11.7.066A1.044,1.044,0,0,1,20.1,1.2V28.23a1.044,1.044,0,0,1-1.057,1.057H1.263A1.1,1.1,0,0,1,.14,28.23V7.877Z",
    transform: "translate(0.785 0.449)",
    fill: "#edeef2",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M.506,8.112.573,28.4a.833.833,0,0,0,.859.859H19.207a.875.875,0,0,0,.859-.859V1.372a.875.875,0,0,0-.859-.859L7.577.446.506,8.112Zm18.7,21.608H1.432A1.325,1.325,0,0,1,.11,28.4V7.98L7.379.05,19.207.116a1.215,1.215,0,0,1,1.256,1.256V28.4A1.27,1.27,0,0,1,19.207,29.72Z",
    transform: "translate(0.617 0.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M.734,2.757a.3.3,0,0,1-.264-.33c0-.2.132-.4.264-.4h9.449c.132,0,.264.2.264.4a.3.3,0,0,1-.264.33Z",
    transform: "translate(2.636 11.384)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M.734,3.727A.3.3,0,0,1,.47,3.4C.47,3.2.6,3,.734,3h9.449c.132,0,.264.2.264.4a.3.3,0,0,1-.264.33Z",
    transform: "translate(2.636 16.824)",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M.734,4.7a.3.3,0,0,1-.264-.33c0-.2.132-.4.264-.4h9.449c.132,0,.264.2.264.4a.3.3,0,0,1-.264.33Z",
    transform: "translate(2.636 22.263)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M5.091,2.6H3.043c0,.066-.066.132-.066.2V4.519a.231.231,0,0,0,.066.132c.066.066.066.066.132.066H5.091a.243.243,0,0,0,.2-.066.231.231,0,0,0,.066-.132V2.8c0-.066-.066-.132-.066-.2h-.2ZM3.175,1.81H5.091a.813.813,0,0,1,.661.33h0a.813.813,0,0,1,.33.661V4.519a.918.918,0,0,1-.33.661h0a1.009,1.009,0,0,1-.661.264H3.175a1.174,1.174,0,0,1-.661-.264h0a1.174,1.174,0,0,1-.264-.661V2.8a1.009,1.009,0,0,1,.264-.661h0a.918.918,0,0,1,.661-.33h0Z",
    transform: "translate(12.618 10.15)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M5.091,3.517H3.043c0,.066-.066.132-.066.2V5.433a.231.231,0,0,0,.066.132c.066.066.066.066.132.066H5.091a.243.243,0,0,0,.2-.066.231.231,0,0,0,.066-.132V3.715c0-.066-.066-.132-.066-.2ZM3.175,2.79H5.091a.766.766,0,0,1,.661.264h0a.813.813,0,0,1,.33.661V5.433a.918.918,0,0,1-.33.661h0a1.009,1.009,0,0,1-.661.264H3.175a1.174,1.174,0,0,1-.661-.264h0a1.174,1.174,0,0,1-.264-.661V3.715a1.009,1.009,0,0,1,.264-.661h0a.848.848,0,0,1,.661-.264Z",
    transform: "translate(12.618 15.646)",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M5.091,4.487H3.175c-.066,0-.066,0-.132.066a.231.231,0,0,0-.066.132V6.4a.231.231,0,0,0,.066.132c.066.066.066.066.132.066H5.091a.243.243,0,0,0,.2-.066A.231.231,0,0,0,5.356,6.4V4.685a.231.231,0,0,0-.066-.132A.243.243,0,0,0,5.091,4.487ZM3.175,3.76H5.091a.766.766,0,0,1,.661.264h0a.813.813,0,0,1,.33.661V6.4a.918.918,0,0,1-.33.661h0a.766.766,0,0,1-.661.264H3.175a.848.848,0,0,1-.661-.264h0A1.174,1.174,0,0,1,2.25,6.4V4.685a1.009,1.009,0,0,1,.264-.661h0a.848.848,0,0,1,.661-.264Z",
    transform: "translate(12.618 21.086)",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M7.537.02V6.892A1.114,1.114,0,0,1,6.414,8.016H.07l7.467-8Z",
    transform: "translate(0.393 0.112)",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M.991,7.93H6.806A.9.9,0,0,0,7.731,7V.661L.991,7.93Zm5.815.4H0L7.8,0l.33.132V7A1.325,1.325,0,0,1,6.806,8.326Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting-icon.3f744ce03bb7f29c9820fdd04c5cc1c1.svg";
export { ForwardRef as ReactComponent };